export type ExecutionStatusFilter =
  | ExecutionStatusFilterEnum.All
  | ExecutionStatusFilterEnum.ActionPending
  | ExecutionStatusFilterEnum.Completed;

export enum ExecutionStatusFilterEnum {
  All = "All",
  ActionPending = "ActionPending",
  Completed = "Completed",
}

export const EXECUTION_STATUS = {
  All: {
    label: "All",
    value: ExecutionStatusFilterEnum.All,
  },
  // [BreifInfluencerV2StatusEnum.Shortlisted]: {
  //   label: "Discovery",
  //   description: "Creators identified as campaign-fit",
  //   value: BreifInfluencerV2StatusEnum.Shortlisted,
  //   icon: (
  //     <img
  //       src={"/Discovery.svg"}
  //       alt="Discover Square"
  //       style={{ width: 14, height: 14 }}
  //     />
  //   ),
  // },
  // [ExecutionStatusFilterEnum.ActionPending]: {
  //   label: "Action Pending",
  //   value: ExecutionStatusFilterEnum.ActionPending,
  // },
  [ExecutionStatusFilterEnum.Completed]: {
    label: "Completed",
    value: ExecutionStatusFilterEnum.Completed,
  },
};
